export function spyOn(target, fnName, callback) {
    const t = target;
    const originalFn = t[fnName];
    // eslint-disable-next-line func-names
    t[fnName] = function (...args) {
        try {
            return originalFn.call(this, ...args);
        }
        finally {
            callback(...args);
        }
    };
    return () => {
        t[fnName] = originalFn;
    };
}
export function listenOn(target, type, listener) {
    target.addEventListener(type, listener);
    return () => {
        target.removeEventListener(type, listener);
    };
}
export function uuid() {
    const HEX_ALPHA = '0123456789abcdef';
    return 'xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, () => HEX_ALPHA[(Math.random() * 16) | 0]);
}
export function utf8ToBase64(str) {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    const binary = String.fromCharCode(...bytes);
    return btoa(binary);
}
export var Cookie;
(function (Cookie) {
    function set(key, value, opt = {}) {
        const parts = [`${encodeURIComponent(key)}=${encodeURIComponent(value)}`];
        if (opt.expires) {
            parts.push(`expires=${opt.expires.toUTCString()}`);
        }
        else if (typeof opt.maxAge === 'number') {
            parts.push(`expires=${new Date(Date.now() + opt.maxAge * 1000).toUTCString()}`);
        }
        if (opt.sameSite) {
            parts.push('samesite');
        }
        if (opt.domain) {
            parts.push(`domain=${encodeURIComponent(opt.domain)}`);
        }
        if (opt.secure) {
            parts.push('secure');
        }
        document.cookie = parts.join('; ');
    }
    Cookie.set = set;
    function get(key) {
        const prefix = `${encodeURIComponent(key)}=`;
        const documentCookie = document.cookie.split(/;\s*/g).find(cookie => cookie.startsWith(prefix));
        return documentCookie && decodeURIComponent(documentCookie.slice(prefix.length));
    }
    Cookie.get = get;
    function remove(key) {
        set(key, '', { maxAge: 0 });
    }
    Cookie.remove = remove;
})(Cookie || (Cookie = {}));
//# sourceMappingURL=utils.js.map